// extracted by mini-css-extract-plugin
export default {"eventSoldOutMessage":"SeriesNotification-module__eventSoldOutMessage___1nWOT"};